import { jsx, jsxs } from "react/jsx-runtime";
import { ColorTextLight, ColorTextDefault } from "@nxt-costco-com/forge-design-tokens";
import { StyledSpan } from "../styles.js";
import { Text } from "../../Text/index.js";
function ReviewCount({
  display,
  reviewCount,
  displayVariant,
  textSize,
  emptyReviewText
}) {
  var _a;
  if (!display) {
    return null;
  }
  if (!Number(reviewCount) && emptyReviewText) {
    return /* @__PURE__ */ jsx(
      Text,
      {
        sx: {
          color: displayVariant === "compact" ? ColorTextLight : ColorTextDefault,
          paddingTop: "2px"
        },
        variant: textSize,
        "aria-hidden": true,
        children: /* @__PURE__ */ jsx(StyledSpan, { displayVariant, children: emptyReviewText })
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    Text,
    {
      sx: {
        color: displayVariant === "compact" ? ColorTextLight : ColorTextDefault,
        paddingTop: "2px"
      },
      variant: textSize,
      "aria-hidden": true,
      children: [
        "(",
        /* @__PURE__ */ jsx(StyledSpan, { displayVariant, children: (_a = Number(reviewCount)) == null ? void 0 : _a.toLocaleString() }),
        ")"
      ]
    }
  );
}
export {
  ReviewCount
};
